<div class="bg-color-base-2500 h-100vh">
    <grid-row *ngIf="RequestLetter==false" class="justify-content-center align-content-center h-100">
        <grid-col col="4" mobile="11"  ipad="8" class="text-align-center">
                <ng-icon iconClass="icon-success-100px" width="100" height="100"></ng-icon>
                
            <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3" *ngIf="this.PaymentID != '' && this.result == 'CAPTURED'" >
                {{"YourPaymentHasSuccessfull" | translate}}
            </div>
            <!-- <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3" >
                {{"YouHaveChangedCardPIN" | translate}}
            </div> -->
            <!-- <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3">
                {{"YouReceiveLetter" | translate}}
            </div> -->
            <!-- <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3">
                {{"AppliedVirtualCard" | translate}}
            </div> -->
            <!-- <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3">
                {{"SuccessfullyAppliedPhysicalCard" | translate}}
            </div> -->
            <!-- <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3">
                {{"YNewSupplementaryCard" | translate}}
            </div> -->
            <!-- <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3">
                {{"SupplementaryCardReadyUse" | translate}}
            </div> -->
            <!-- <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3">
                {{"YouSuccessfullyReplacement" | translate}}
            </div> -->
            <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3"   *ngIf="this.Screen == 'Reissue'">
                {{"TemporaryPINSent" | translate}}
            </div>
            <!-- <div class="font-400 font-size-16px color-base-700 line-h-22 mt-10 letter-spacing-1" *ngIf="this.PaymentID">
                {{"NotificationLinked" | translate}}
            </div> -->
            <!-- <div class="font-400 font-size-16px color-base-700 line-h-22 mt-10 letter-spacing-1">
                {{"WewillRequested" | translate}}
            </div> -->
            <!-- <div class="font-400 font-size-16px color-base-700 line-h-22 mt-10 letter-spacing-1">
                {{"VirtualCardNumbersUpdated" | translate}}
            </div> -->
            <!-- <div class="font-400 font-size-16px color-base-700 line-h-22 mt-10 letter-spacing-1">
                {{"YourNewCardWillDelivered" | translate}}
            </div> -->
            <!-- <div class="font-400 font-size-16px color-base-700 line-h-22 mt-10 letter-spacing-1">
                {{"ReceivePhysicalCard" | translate}}
            </div> -->
            <!-- <div class="font-400 font-size-16px color-base-700 line-h-22 mt-10 letter-spacing-1">
                {{"DigitalCardIssued" | translate}}
            </div> -->
            <!-- <div class="font-400 font-size-16px color-base-700 line-h-22 mt-10 letter-spacing-1">
                {{"YourNewCardReady" | translate}}
            </div> -->
            <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3" *ngIf="this.flow=='StopCard'">
                {{"CardStopped" | translate}}
            </div>
            <div class="font-400 font-size-16px color-base-700 line-h-22 mt-10 letter-spacing-1" *ngIf="this.flow=='StopCard'">
                {{"YouWillReceiveNotification" | translate}}
            </div>

            <grid-row class="justify-content-center" *ngIf="this.flow=='StopCard'">
                <grid-col col="10" mobile="11">
                    <grid-row class="mt-30">
                        <grid-col col="12">
                            <button class="btn-dft-border" (click)="Dashboard()">
                                {{ "Done" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
            <grid-row class="justify-content-center" *ngIf="this.PaymentID  && this.result == 'CAPTURED'">
                <grid-col col="10" mobile="11">
                
                    <grid-row class="align-content-center justify-content-between mt-30">
                        <grid-col col="auto">
                            <div class="font-400 font-size-20px color-base-700">
                                {{ "AmountPaid" | translate }}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-500 font-size-20px color-base-700">
                                {{ "BHD" | translate }} {{this.amount}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="align-content-center justify-content-between mt-15">
                        <grid-col col="auto">
                            <div class="font-400 font-size-20px color-base-700">
                                {{ "Date" | translate }}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-500 font-size-20px color-base-700">
                               {{this.currentDate |  date : "dd MMM yyyy"}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="align-content-center justify-content-between mt-15">
                        <grid-col col="auto">
                            <div class="font-400 font-size-20px color-base-700">
                                {{ "Time" | translate }}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-500 font-size-20px color-base-700">
                               {{this.time |  date : "hh:mm a"}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="align-content-center justify-content-between mt-15">
                        <grid-col col="auto">
                            <div class="font-400 font-size-20px color-base-700">
                                {{ "RefID" | translate }}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-500 font-size-20px color-base-700">
                                {{this.PaymentID}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="mt-30">
                        <grid-col col="12">
                            <!-- <button class="btn-dft-border" (click)="Return()">
                                {{ "Done" | translate }}
                            </button> -->
                            <ng-container *ngIf="quickPayFlow === 'Quick'; else defaultButton">
                                <button class="btn-dft-border" (click)="Returnprelogin()">
                                    {{ "Done" | translate }}
                                </button>
                            </ng-container>
                            <ng-template #defaultButton>
                                <button class="btn-dft-border" (click)="Return()">
                                    {{ "Done" | translate }}
                                </button>
                            </ng-template>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
            <grid-row class="mt-30" *ngIf="this.Screen == 'Reissue'">
                <grid-col col="12">
                    <button class="btn-dft" (click)="Return()">
                        {{ "CHANGENOW" | translate }}
                    </button>
                </grid-col>
                <grid-col col="12">
                    <button class="btn-dft-border mt-15" (click)="Return()">
                        {{ "MAYBELATER" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </grid-col>
    </grid-row>
    <grid-row *ngIf="RequestLetter==true" class="justify-content-center align-content-center h-100">
        <grid-col col="4" mobile="11" class="text-align-center">
                <ng-icon iconClass="icon-success-100px" width="100" height="100"></ng-icon>
                <!-- Request Outstanding Balance Letter Success -->
                    <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40">
                        {{ "YouReceiveLetterEmail" | translate }}
                    </div>
                    <div class="font-400 font-size-20px color-primary-shade-200 mt-40">
                        {{ "RequestedLetterTo" | translate }}
                    </div>
                    <div  class="font-400 font-size-20px color-base-100">
                        {{this.Email}}
                    </div>
                    <grid-row class="justify-content-center">
                        <grid-col col="8">
                            <grid-row class="justify-content-between align-item-center mt-24">
                                <grid-col col="auto">
                                    <div class="font-400 font-size-20px color-base-700 mt-40">
                                        {{ "RefId" | translate }} 
                                    </div>
                                </grid-col>
                                <grid-col col="auto">
                                    <div class="font-500 font-size-20px color-base-700 mt-40">
                                        {{this.RefId}}
                                    </div>
                                </grid-col>
                            </grid-row>
                        </grid-col>
                    </grid-row>
            <grid-row class="justify-content-center mt-30">
                <grid-col col="8" mobile="11">
                    <button class="btn-dft-border" (click)="Return()">
                        {{ "Done" | translate }}
                    </button>
                </grid-col>
            </grid-row>
            <!-- <grid-row class="justify-content-center mt-30">
                <grid-col col="8" mobile="11">
                    <button class="btn-dft-border">
                        {{ "CHANGENOW" | translate }}
                    </button>
                    <button class="btn-dft-border no-bg mt-20">
                        {{ "MAYBELATER" | translate }}
                    </button>
                </grid-col>
            </grid-row> -->
        </grid-col>
    </grid-row>
</div>
